'use client'

import React, { useState, useEffect, useRef } from 'react'
import asset from '../utils/assetUrl'

export default function Timeline() {
    const [scrollProgress, setScrollProgress] = useState(0)
    const timelineRef = useRef(null) // Fixed TypeScript syntax

    const timelineData = [
        {
            title: "Inscríbete",
            content: "Llenas el formulario con tus datos y la ciudad a la que vas a asistir. Toma menos de un minuto y no tiene ningún costo.",
            image: "/assets/images/registro-2.jpg" // Use actual image path
        },
        {
            title: "Recibe tu confirmación",
            content: "Te llega un correo con la sede exacta, la fecha y el horario de tu ciudad, y dentro tu código QR personal. Guárdalo: ese código es tu pase el día del evento.",
            image: "/assets/images/confirmacion-2.jpg"
        },
        {
            title: "Asiste al evento",
            content: "Escuchas la conferencia y después te acercas a los expositores a preguntar por programas, requisitos, costos de vida y opciones de trabajo. Les muestras tu código QR y reciben tus datos para enviarte su información. Lleva tu identificación oficial, INE o pasaporte.",
            image: "/assets/images/conf.jpg"
        },
        {
            title: "Empieza tu proceso",
            content: "Sales sabiendo qué programa encaja contigo, en qué provincia tiene sentido y a quién escribirle para dar el siguiente paso.",
            image: "/assets/images/final.jpg"
        }
    ]

    // Optimized scroll handler with throttling
    useEffect(() => {
        let ticking = false

        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    if (timelineRef.current) {
                        const rect = timelineRef.current.getBoundingClientRect()
                        const viewportHeight = window.innerHeight
                        const totalDistance = rect.height + viewportHeight
                        const progress = Math.min(Math.max((viewportHeight - rect.top) / totalDistance, 0), 1)

                        setScrollProgress(progress)
                    }
                    ticking = false
                })
                ticking = true
            }
        }

        window.addEventListener('scroll', handleScroll, { passive: true })
        // set initial state
        handleScroll()

        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    // Extracted timeline line styles for better readability
    const lineStyles = {
        // La geometria (posicion y alto) la pone .timeline__line en el SCSS,
        // que la ancla al centro de cada bandera. Aqui solo el color.
        base: {
            backgroundColor: '#E0E0E0'
        },
        progress: {
            left: '0',
            top: '0',
            width: '100%',
            backgroundColor: '#b00000',
            height: `${scrollProgress * 100}%`,
            transition: 'height 0.1s ease-out',
            zIndex: 2
        }
    }

    return (
        <div className="block timeline-block" ref={timelineRef}>
            {/* Banderas al inicio y al final de la línea: el recorrido es de
                México a Canadá, igual que en las piezas de confirmación.
                PNG local y no emoji, porque Windows no trae fuente de banderas. */}
            <span className="timeline__flag timeline__flag--start">
                <img src={asset("/assets/images/flag-mx.png")} alt="" aria-hidden="true" />
            </span>

            {/* La linea vive aqui y no dentro de .timeline para que llegue
                de bandera a bandera: antes terminaba donde acababa la lista de
                pasos y quedaba un hueco antes de la de Canada. */}
            <div className="timeline__line" style={lineStyles.base}>
                <div className="position-absolute" style={lineStyles.progress} />
            </div>

            <div className="timeline position-relative">
                {timelineData.map((item, index) => (
                    <div
                        key={index}
                        className={`row align-items-center mb-5 timeline-item-content ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}
                    >
                        <div className="col-md-6 mb-4 mb-md-0">
                            <img
                                src={asset(item.image)}
                                alt={item.title}
                                className="img-fluid"
                                loading="lazy"
                            />
                        </div>
                        <div className="col-md-6 position-relative">
                            <div
                                className="position-absolute"
                                style={{
                                    top: '50%',
                                    [index % 2 === 0 ? 'left' : 'right']: '-9px',
                                    width: '20px',
                                    height: '20px',
                                    backgroundColor: '#b00000',
                                    borderRadius: '50%',
                                    transform: 'translateY(-50%)',
                                    zIndex: 2
                                }}
                            />
                            <div className={`p-4 timeline-item-content-text ${index % 2 === 0 ? 'text-start' : 'text-end'}`}>
                                <h2 className="text-danger">{item.title}</h2>
                                <p className="">{item.content}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <span className="timeline__flag timeline__flag--end">
                <img src={asset("/assets/images/flag-ca.png")} alt="" aria-hidden="true" />
            </span>
        </div>
    )
}
